// src/pages/LoginPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Login from '../components/Login';

const LoginPage = ({ setToken }) => {
  const navigate = useNavigate();

  const handleLogin = (token) => {
    setToken(token);
    console.log("Token actual en loginPage.js:", token);
    navigate('/select-company');
  };

  return <Login setToken={handleLogin} />;
};

export default LoginPage;
